import crypto from "crypto"

export const hashEmail = (email: string) => {
  email = email.trim().toLowerCase()
  const utf8Email = Buffer.from(email, "utf-8")

  return crypto.createHash("sha256").update(utf8Email).digest("hex")
}
